import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

import { TranslateModule } from '@ngx-translate/core';

export interface DialogData {
  helpful: boolean;
}

@Component({
  selector: 'inbox-response-evaluation-dialog-component',
  templateUrl: 'response-evaluation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    GalaxyFormFieldModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    TranslateModule
],
})
export class ResponseEvaluationDialogComponent {
  readonly data = inject(MAT_DIALOG_DATA);
  icon = this.data.helpful ? 'thumb_up' : 'thumb_down';
  label = this.data.helpful
    ? 'INBOX.RESPONSE_EVALUATION.HELPFUL_QUESTION'
    : 'INBOX.RESPONSE_EVALUATION.NOT_HELPFUL_QUESTION';

  evaluationForm = new FormGroup({
    comment: new FormControl(),
  });

  constructor(public dialogRef: MatDialogRef<ResponseEvaluationDialogComponent>) {}

  submit(): void {
    this.dialogRef.close({ comment: this.evaluationForm.value.comment });
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    event.stopPropagation();
    // while the modal is open, prevent clicks from causing the thumbs to hide below the message bubble
  }
}
